var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.144,
    height: 12.635,
    viewBox: "0 0 17.144 12.635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5749",
    "data-name": "Group 5749",
    transform: "translate(-0.001 -29.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M17.144,70.024a.713.713,0,0,0-.1-.32l-3.214-5.358A.714.714,0,0,0,13.215,64H11.123v1.429h1.687l2.571,4.286h-1.81a1.43,1.43,0,0,0-1.429,1.429.715.715,0,0,1-.714.714H5.716A.715.715,0,0,1,5,71.143a1.43,1.43,0,0,0-1.429-1.429H1.763l2.571-4.286H6.257V64H3.93a.714.714,0,0,0-.612.347L.1,69.7a.712.712,0,0,0-.1.32c0,.016,0,4.037,0,4.037A1.43,1.43,0,0,0,1.43,75.49H15.715a1.43,1.43,0,0,0,1.429-1.429S17.146,70.04,17.144,70.024Z",
    transform: "translate(0 -33.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5748",
    "data-name": "Group 5748",
    transform: "translate(6.463 29.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M197.479,53.578a.107.107,0,0,0-.1-.066H196.2V50.839a.106.106,0,0,0-.007-.038v.291a.1.1,0,0,1-.1.1h-1.705a.1.1,0,0,1-.1-.1v-.285a.105.105,0,0,0-.005.031v2.674h-1.172a.107.107,0,0,0-.1.066.106.106,0,0,0-.008.041.108.108,0,0,0,.031.076l2.14,2.141a.107.107,0,0,0,.151,0l2.134-2.141A.108.108,0,0,0,197.479,53.578Z",
    transform: "translate(-193 -50.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M231.45,30.907h1.705a.1.1,0,0,0,.1-.1v-.89a.1.1,0,0,0-.1-.1H231.45a.1.1,0,0,0-.1.1v.89A.1.1,0,0,0,231.45,30.907Z",
    transform: "translate(-230.062 -29.809)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveicon);
export default __webpack_public_path__ + "static/media/Archiveicon.8d5850b28cddbafce37448fce0a26d11.svg";
export { ForwardRef as ReactComponent };